export enum BloodGroup {
    O = 1,
    A = 2,
    B = 3,
    AB = 4
}